module.exports = __webpack_public_path__ + "static/media/quality.a8d1c049.svg";